import { Component, Input } from '@angular/core';
import { LoaderService } from '../../services/loader.service';

@Component({
  selector: 'app-error-screen',
  templateUrl: './error-screen.component.html',
  styleUrls: ['./error-screen.component.css']
})
export class ErrorScreenComponent {
  @Input() title: string = 'Error';
  @Input() description: string = 'Ha ocurrido un problema inesperado. Por favor, inténtalo de nuevo más tarde.';

  constructor(private _loaderService: LoaderService){
    this._loaderService.hide();
  }
}